import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as Yup from "yup";

import { AxiosError } from "axios";
import { useCallback, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { baseAppPath, RECAPTCHA_KEY } from "../../../config/GlobalConfig";
import { SESSION_STORAGE_KEYS } from "../../../const/AppConst";
import MgpButton from "../../../elements/MgpButton/MgpButton";
import MgpFormInput from "../../../elements/MgpFormInput/MgpFormInput";
import MgpMessage from "../../../elements/MgpMessage/MgpMessage";
import { createNewPass, initNewPass } from "../../../services/AuthService";
import { ICreatePasswordRequest, IInitPasswordRequest } from "../../../services/model";
import { useSessionStorage } from "../../../utils/utils";
import LoaderActionComponent from "../../common/LoaderActionComponent";
import { useGoogleReCaptcha } from "react-google-recaptcha-hook";

export default function InitPasswordEntrepriseComponent() {
  const validationSchema = Yup.object().shape({
    password: Yup.string()
      .required("Veuillez renseigner votre mot de passe")
      .min(8, "Votre mot de passe doit avoir minimum 8 caractères")
      .max(15, "Votre mot de passe doit avoir maximum 15 caractères")
      .matches(/\d+/, "Votre mot de passe doit avoir au moins un chiffre")
      .matches(/[a-z]+/, "Votre mot de passe doit avoir au moins une minuscule")
      .matches(/[A-Z]+/, "Votre mot de passe doit avoir au moins une majuscule")
      .matches(/[!@#&()–:;',?/*~$^+=<>]+/, "Votre mot de passe doit avoir au moins un caractère spécial")
      .test("no-space", "Votre mot de passe ne doit pas contenir d'espace", (val) => {
        return val !== 'undefined' && !/\s+/.test(val!);
      }),
    confirmedPassword: Yup.string()
      .required("Veuillez confirmer votre mot de passe")
      .min(6, "Votre mot de passe est incorrect")
      .when('password', (password, schema) => {
        return schema.test("same-pass", "Votre confirmation de mot de passe n'est pas cohérente", (val: string) => {
          return val && password && val === password;
        }); 
      }),
  });

  const [errorMsg, setErrorMsg] = useState<string | null>();
  const [loading, setLoading] = useState<boolean>(false);
  const [initLink, setInitLink] = useState<number>(0);

  const [success, setSuccess] = useState<boolean>(false);
  const [searchParams] = useSearchParams();
  let initToken = searchParams.get("token");
  const [accessToken, setAccessToken] = useSessionStorage(SESSION_STORAGE_KEYS.initPassToken + "EE" + "_" + initToken, "");
  const navigate = useNavigate();

  const { executeGoogleReCaptcha } = useGoogleReCaptcha(
    `${RECAPTCHA_KEY}`,
    {
      language: 'fr',
      enterprise: true,
      recaptchaNet: true, 
    }
  );
  


  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting, isDirty },
  } = useForm<ICreatePasswordRequest>({
    mode: "onBlur",
    reValidateMode: "onChange",
    defaultValues: {
      password: "",
      confirmedPassword: "",

    },
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = async (data: ICreatePasswordRequest) => {
    console.log("click");

    setErrorMsg(null);
    setLoading(true);
    try {
      const recaptchaToken = await executeGoogleReCaptcha("createNewPassword");
      console.log(recaptchaToken);
      data.recaptchaToken = recaptchaToken;
      await createNewPass("EE", accessToken, data);
      setSuccess(true);
      sessionStorage.clear();
    } catch (error) {
      setLoading(false);
      const err = error as AxiosError;
      console.log(err);
      if(err.response && (err.response.status === 401 || err.response.status === 400 || err.response.status === 403)) {
        setErrorMsg("Votre demande est invalide");
      } else {
        setErrorMsg("Une erreur technique est survenue. Veuillez réessayer ultérieurement");
      }
    }

  };

  const onLoad = useCallback(async () => {
    let tempToken = accessToken;
    if(!initToken || initToken.length < 5) {
      navigate(baseAppPath, { replace: true });
    }
    try {
      
      if(initToken && !tempToken) {
        const gRecaptchaToken = await executeGoogleReCaptcha("initNewPassword");
        console.log(gRecaptchaToken);
        const payload = await initNewPass("EE", {token: initToken, recaptchaToken: gRecaptchaToken} as IInitPasswordRequest);
        tempToken = payload.data.accessToken
        setAccessToken(tempToken);
        setInitLink(1);
      }  
    } catch (error) {
      console.log(error);
    }
    
    if(!tempToken) {
      setErrorMsg("Le lien n'est plus valide. Si vous souhaitez obtenir un nouveau lien, merci de cliquer sur le bouton ci-dessous:");
      setInitLink(-1);
    } else {
      setInitLink(1);
    }
  }, [])

  return (
    <>
    {initLink ===0 && <LoaderActionComponent onLoad={onLoad}/>}
    
    {success&&(<>
      <MgpMessage type="success" message="Votre mot de passe a été réinitialisé. Vous pouvez connecter sur votre espace dès maintenant" hasCloseBtn={false}/>
      <div className="wrapper-cta-inline m-y-lg"> 
        <Link to={baseAppPath} className="cta-bleu text ta-center">Me connecter</Link>
      </div>
      </>
    )}
    {errorMsg && 
    <>
      <MgpMessage type="danger" message={errorMsg} hasCloseBtn={false}/>
      {initLink===-1&&<div className="wrapper-cta-inline m-y-lg"> 
        <Link to={baseAppPath + "/oublie-mot-passe"} className="cta-bleu text ta-center">Obtenir un nouveau lien</Link>
      </div>}
    </>
    }
    {!success&&initLink ===1&&<form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
      
      <div className="form-group">
      <MgpFormInput
          label="Mon mot de passe"
          register={register}
          type="password"
          id="password"
          icon="oeil"
          iconPosition="right"
          errors={errors}
          disabled={isSubmitting || loading}
        />
        
      </div>
      <div className="form-group">
      <MgpFormInput
          label="Confirmation de mon mot de passe"
          register={register}
          type="password"
          id="confirmedPassword"
          icon="oeil"
          iconPosition="right"
          errors={errors}
          disabled={isSubmitting || loading}
        />
      </div>
      
      <div className="form-group">
        <MgpButton
          id="submitButton"
          type="submit"
          text="Enregistrer"
          disabled={isSubmitting || loading} loading={isSubmitting || loading}
        />
      </div>
      <div className="mt-xl">
        <h2 className="fz-lg fw-bold mb-lg">Pour rappel, le mot de passe respectera la norme suivante : </h2>
        <ul className="list-bullet-bleu fw-medium">
          <li>Minimum 8 caractères</li>
          <li>Maximum 15 caractères</li>
          <li>Au moins une majuscule</li>
          <li>Au moins une minuscule</li>
          <li>Au moins un chiffre</li>
          <li>Au moins un caractère spécial</li>
          <li>Pas d'espace</li>
        </ul>
      </div>
    </form>}
    </>
  );
}
